import React, { CSSProperties } from 'react';
import { formatNumberToDisplayType } from 'modules/Utils';
import Colors from 'modules/Colors';
import Sty from 'modules/Sty';

export interface LineItem {
    type: string;
    name: string;
    description?: string;
    amount: number;
    currency: string;
}

interface LineItemsSummaryProps {
    lineItems: LineItem[];
    totalAmount: number;
    title?: string;
    showTitle?: boolean;
    isLoading?: boolean;
    className?: string;
    style?: CSSProperties;
}

const LineItemsSummary: React.FC<LineItemsSummaryProps> = ({
    lineItems,
    totalAmount,
    title = 'Summary',
    showTitle = true,
    isLoading = false,
    className = '',
    style = {}
}) => {
    if (isLoading) {
        return (
            <div style={{
                padding: 24,
                textAlign: 'center',
                color: '#707070',
                backgroundColor: Colors.greyLight,
                borderRadius: 8,
                ...style
            }}>
                <div style={{ fontSize: 16, marginBottom: 8 }}>Calculating fees...</div>
                <div style={{ fontSize: 14 }}>Please wait while we determine the best pricing for your campaign</div>
            </div>
        );
    }

    return (
        <div className={`lineItemsSummary ${className}`} style={style}>
            {showTitle && (
                <div style={{
                    marginBottom: 16,
                    paddingBottom: 12,
                    borderBottom: '1px solid #f0f0f0'
                }}>
                    <div style={{ fontSize: 16, fontWeight: 600, color: '#1a1d29' }}>
                        {title}
                    </div>
                </div>
            )}
            
            <div className="lineItemsList">
                {lineItems.map((item, index) => (
                    <div 
                        key={index}
                        className="lineItem"
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            padding: '16px 0',
                            borderBottom: '1px solid #f0f0f0'
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ fontWeight: 500 }}>
                                {item.name}
                            </div>
                            {item.description && (
                                <div style={{ fontSize: 12, color: '#707070' }}>
                                    {item.description}
                                </div>
                            )}
                        </div>
                        <div>{formatNumberToDisplayType(item.amount, 'currency')}</div>
                    </div>
                ))}
            </div>

            {/* Total */}
            <div
                className="totalSection"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: 16,
                    backgroundColor: Colors.greyLight,
                    borderRadius: 8,
                    marginTop: 16
                }}
            >
                <div style={Sty.text16bold}>Total charged today</div>
                <div style={Sty.text16}>{formatNumberToDisplayType(totalAmount, 'currency')}</div>
            </div>
        </div>
    );
};

export default LineItemsSummary;